import { ApplicationStoreState } from './state';
import { normalize } from 'normalizr';
import * as schema from '../../../utils/schema';

import * as types from './types';

export default function application(state: any = ApplicationStoreState, action: any) {
  switch (action.type) {
    case types.APPLICATION_SET:
      const applicationL = normalize(action.payload, schema.applications);
      return {
        ...state,
        applicationList: applicationL.entities.applications,
      };
    case types.APPLICATION_BATCH:
      const batch = normalize(action.payload, [schema.batches]);
      return {
        ...state,
        batchList: batch.entities.batches,
      };

    default:
      return state;
  }
}
